/**
 * @mixin
 * Sharable mixin to use with components that are loaded dynamically
 * Helps displaying a loading status
 */
export default {
	mounted() {
		// We're emitting an event to let parent component know that this dynamic component has been successfully loaded
		this.componentLoaded();
	},

	destroyed() {
		// We're emitting an event to let parent component know that this dynamic component has been destroyed and is no longer visible
		this.componentDestroyed();
	},

	methods: {
		/**
		 * @public
		 * @description
		 * Emits an event to indicate that dynamic component has been loaded
		 * 
		 * @returns void
		 */
		componentLoaded() {
			if ( this.$options.name !== 'cs-screen' ) {
				this.$emit('componentLoaded', true);
			}
		},

		/**
		 * @public
		 * @description
		 * Emits and event to indicate that dynamic component has been destroyed and is not available
		 * 
		 * @returns void
		 */
		componentDestroyed() {
			if ( this.$options.name !== 'cs-screen' ) {
				this.$emit('componentDestroyed', false); // false = visibility of the component
			}
		}
	}
}
